import {
  Progress as MantineProgress,
  ProgressProps as MantineProgressProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Progress.module.css';

export type ProgressProps = Omit<
  MantineProgressProps,
  | 'variant'
  | 'color'
  | 'styles'
  | 'classNames'
  | 'style'
  | 'size'
  | 'radius'
  | 'striped'
  | 'animated'
> & {
  className?: string;
};

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, ...props }, ref) => {
    const rootClassName = [styles.root, className].filter(Boolean).join(' ');

    return (
      <MantineProgress
        ref={ref}
        unstyled
        classNames={{
          root: rootClassName,
          section: styles.section,
        }}
        {...props}
      />
    );
  }
);

Progress.displayName = 'Progress';
